import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy grain px-6">
      <div className="relative w-full max-w-md rounded-3xl bg-white p-10 soft-shadow" data-testid="admin-login">
        <div className="flex items-baseline gap-2 mb-8">
          <span className="font-serif text-2xl text-navy">Epic</span>
          <span className="text-[0.65rem] tracking-[0.28em] uppercase text-gold font-semibold pb-0.5">Consultancy</span>
        </div>
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-navy text-gold">
          <Lock size={22} />
        </div>
        <h1 className="font-serif text-2xl text-navy">Admin Sign In</h1>
        <p className="text-sm text-slate-500 mt-1">Manage insights and enquiries.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full bg-navy hover:bg-navy-light text-cream h-11">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
